<template>
  <div>
    <div class="fixed-top">
      <div class="d-flex justify-content-end start-50 translate-middle-x" style="z-index: 1050">
        <h3></h3>
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged" style="width: 25%">
          Success <br />
          Goal has been Updated
          <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress>
        </b-alert>
      </div>
    </div>
    <section class="practice">
      <div class="row">
        <aside class="col-md-3 col-sm-12 cus-sidebar">
          <practiceSidebar />
        </aside>
        <div v-if="isLoading" class="loader">
          <div class="wave-container">
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
          </div>
          <p>Loading...</p>
        </div>

        <div v-if="!isLoading" id="content" class="col-md-9 col-sm-12">
          <div class="material-box bg-white">
            <div class="row content-row">
              <div class="col-md-12 top-title" style="position: relative">
                <div class="d-flex justify-content-between">
                  <h3>Goals by Quarter</h3>
                </div>
              </div>

              <div class="col-md-12">
                <div class="p-b-10 glop_dap">
                  <!-- begin row -->
                  <div class="row">
                    <!-- begin col-12 -->
                    <div class="col-md-12">
                      <div class="glop_dap_head">
                        <h3 class="m-t-0">
                          Quarterly Goals for {{ pageData.year }} -
                          {{ pageData.title }}
                        </h3>
                        <p>
                          Enter your goals for the respective categories. Click
                          the Update button under the day of the week, to record
                          your goal. The number you enter will fill in for each
                          of those days, throughout this quarter.
                        </p>
                      </div>
                      <div class="glop_dap_sec color_sec1">
                        <h3 class="text-center white">New Patients:</h3>
                        <form class="form-horizontal" id="">
                          <div class="content-row">
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Monday" />
                              <label class="control-label m-t-10 m-b-10 white">Monday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Monday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Tuesday" />
                              <label class="control-label m-t-10 m-b-10 white">Tuesday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Tuesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Wednesday" />
                              <label class="control-label m-t-10 m-b-10 white">Wednesday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Wednesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Thursday" />
                              <label class="control-label m-t-10 m-b-10 white">Thursday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Thursday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Friday" />
                              <label class="control-label m-t-10 m-b-10 white">Friday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Friday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Saturday" />
                              <label class="control-label m-t-10 m-b-10 white">Saturday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Saturday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.NP_Sunday" />
                              <label class="control-label m-t-10 m-b-10 white">Sunday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('NP_Sunday')" />
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label class="white">Quarterly Goal:</label>
                                    <!-- :value="formattedNPGoal" -->
                                    <input type="text" :value="formattedNPGoal" id="Focus1Goal_Quarterly"
                                      readonly="readonly" class="control-form" />
                                  </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label class="white">Yearly Goal:</label>
                                    <!-- :value="goals.Y_NP_goal" -->
                                    <input class="control-form" type="text" :value="formattedNPYearGoal"
                                      id="Focus1Goal_Yearly" readonly="readonly" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="glop_dap_sec color_sec2">
                        <h3 class="text-center">Patients Visits:</h3>
                        <form class="form-horizontal">
                          <div class="content-row">
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Monday" id="PV_Monday" />
                              <label class="control-label m-t-10 m-b-10">Monday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Monday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Tuesday" id="PV_Tuesday" />
                              <label class="control-label m-t-10 m-b-10">Tuesday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Tuesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Wednesday"
                                id="PV_Wednesday" />
                              <label class="control-label m-t-10 m-b-10">Wednesday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Wednesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Thursday" id="PV_Thursday" />
                              <label class="control-label m-t-10 m-b-10">Thursday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Thursday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Friday" id="PV_Friday" />
                              <label class="control-label m-t-10 m-b-10">Friday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Friday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Saturday" id="PV_Saturday" />
                              <label class="control-label m-t-10 m-b-10">Saturday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Saturday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.PV_Sunday" id="PV_Sunday" />
                              <label class="control-label m-t-10 m-b-10">Sunday</label>
                              <input type="button" class="btn btn-primary btn-block btn-blue" value="Update"
                                @click="UpdateQuarter('PV_Sunday')" />
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label>Quarterly Goal:</label>
                                    <!-- :value="goals.PV_goal" -->
                                    <input class="control-form" type="text" :value="formattedPVGoal" readonly="readonly"
                                      id="Focus3Goal_Quarterly" />
                                  </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label>Yearly Goal:</label>
                                    <!-- :value="goals.Y_PV_goal" -->
                                    <input class="control-form" type="text" :value="formattedYPVGoal"
                                      readonly="readonly" id="Focus3Goal_Yearly" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="glop_dap_sec color_sec3">
                        <h3 class="text-center white">Revenue:</h3>
                        <form class="form-horizontal">
                          <div class="content-row">
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Monday" id="REV_Monday" />
                              <label class="control-label m-t-10 m-b-10 white">Monday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Monday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Tuesday" id="REV_Tuesday" />
                              <label class="control-label m-t-10 m-b-10 white">Tuesday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Tuesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Wednesday"
                                id="REV_Wednesday" />
                              <label class="control-label m-t-10 m-b-10 white">Wednesday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Wednesday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Thursday"
                                id="REV_Thursday" />
                              <label class="control-label m-t-10 m-b-10 white">Thursday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Thursday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Friday" id="REV_Friday" />
                              <label class="control-label m-t-10 m-b-10 white">Friday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Friday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Saturday"
                                id="REV_Saturday" />
                              <label class="control-label m-t-10 m-b-10 white">Saturday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Saturday')" />
                            </div>
                            <div class="col-md-2">
                              <input type="text" class="form-control" v-model="formdata.REV_Sunday" id="REV_Sunday" />
                              <label class="control-label m-t-10 m-b-10 white">Sunday</label>
                              <input type="button" class="btn btn-default btn-block btn-white" value="Update"
                                @click="UpdateQuarter('REV_Sunday')" />
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label class="white">Quarterly Goal:</label>
                                    <!-- :value="`$${goals.REV_goal}`" -->
                                    <input class="control-form" type="text" :value="`$${formattedREVGoal}`"
                                      readonly="readonly" />
                                  </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                  <div class="quarl_toal text-center">
                                    <label class="white">Yearly Goal:</label>
                                    <!-- :value="`$${goals.Y_REV_goal}`" -->
                                    <input class="control-form" type="text" :value="`$${formattedYREVGoal}`"
                                      readonly="readonly" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <!-- end col-12 -->
                  </div>
                  <!-- end row -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import practiceSidebar from "./../../Practice/components/Sidebar.vue";
import moment from "moment";
import userAPI from "../../userApi";
export default {
  name: "quarter_dashboard",
  components: {
    practiceSidebar,
  },
  data() {
    return {
      isLoading: false,
      dismissSecs: 1,
      dismissCountDown: 0,
      formdata: {},
      years: [],
      loginUser: {},
      pageData: {
        year: "",
        title: "",
        sdate: "",
        edate: "",
      },
      goals: {},
    };
  },
  computed: {
    formattedNPGoal() {
      return this.formatNumberd(this.goals.NP_goal);
    },
    formattedNPYearGoal() {
      return this.formatNumberd(this.goals.Y_NP_goal);
    },
    formattedPVGoal() {
      return this.formatNumberd(this.goals.PV_goal);
    },
    formattedYPVGoal() {
      return this.formatNumberd(this.goals.Y_PV_goal);
    },
    formattedREVGoal() {
      return this.formatNumber(this.goals.REV_goal);
    },
    formattedYREVGoal() {
      return this.formatNumber(this.goals.Y_REV_goal);
    }
  },
  methods: {
    formatNumberd(value) {
      const wholeNumber = Math.floor(value);
      return wholeNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    formatNumber(value) {
      if (value == null) {
        return 0;
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    UpdateQuarter(goal) {
      let update_goal = goal.split("_")[0];
      let update_day = goal.split("_")[1];
      userAPI.addEditQuarterGoal(
        {
          ...this.pageData,
          ...{
            goal_qty: this.formdata[goal],
            update_goal,
            update_day,
            practiceID: this.loginUser.PracticeID,
            userID: this.loginUser.userID,
          },
        },
        (res) => {
          Object.keys(res.data).forEach((ele) => {
            this.goals[ele] = res.data[ele];
          });
          this.showAlert();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getQuarter() {
      this.isLoading = true;
      userAPI.getQuarter(
        { ...this.pageData, ...{ PracticeID: this.loginUser.PracticeID } },
        (res) => {
          this.goals = res.data.data;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
  },
  mounted() {
    if (this.$route.params.quarter != undefined) {
      if (this.$route.params.q == 1) {
        this.pageData.title = "1st Quarter";
        this.pageData.year = this.$route.params.quarter.year;
        this.pageData.sdate = moment(this.pageData.year + "-01-01").format(
          "Y-MM-DD"
        );
        this.pageData.edate = moment(this.pageData.year + "-03-31").format(
          "Y-MM-DD"
        );
      } else if (this.$route.params.q == 2) {
        this.pageData.title = "2nd Quarter";
        this.pageData.year = this.$route.params.quarter.year;
        this.pageData.sdate = moment(this.pageData.year + "-04-01").format(
          "Y-MM-DD"
        );
        this.pageData.edate = moment(this.pageData.year + "-06-30").format(
          "Y-MM-DD"
        );
      } else if (this.$route.params.q == 3) {
        this.pageData.title = "3rd Quarter";
        this.pageData.year = this.$route.params.quarter.year;
        this.pageData.sdate = moment(this.pageData.year + "-07-01").format(
          "Y-MM-DD"
        );
        this.pageData.edate = moment(this.pageData.year + "-09-30").format(
          "Y-MM-DD"
        );
      } else if (this.$route.params.q == 4) {
        this.pageData.title = "4th Quarter";
        this.pageData.year = this.$route.params.quarter.year;
        this.pageData.sdate = moment(this.pageData.year + "-10-01").format(
          "Y-MM-DD"
        );
        this.pageData.edate = moment(this.pageData.year + "-12-31").format(
          "Y-MM-DD"
        );
      } else {
        this.$router.push({ name: "quarter_dashboard" });
      }
    } else {
      this.$router.push({ name: "quarter_dashboard" });
    }
    this.loginUser = JSON.parse(localStorage.getItem("userDetails"));
    this.getQuarter();
  },
};
</script>

<style>
.fixed-top {
  position: fixed;
  top: 10%;
  right: 5%;
  width: 100%;
  z-index: 1050;
  /* Adjust z-index as needed */
}

.glop_dap .glop_dap_head {
  background-color: #ffffff;
  text-align: center;
}

.glop_dap_head h3 {
  margin: 0;
  padding: 15px 20px;
  color: #3c454d;
}

.glop_dap_head p {
  margin: 0;
  padding: 15px 20px;
}

.glop_dap .glop_dap_sec {
  padding: 15px 0;
  text-align: center;
}

.glop_dap_sec.color_sec1 {
  background-color: #2f5196;
}

.glop_dap_sec.color_sec2 {
  background-color: #ffffff;
}

.glop_dap_sec.color_sec3 {
  background-color: #2f5196;
}

.glop_dap_sec h3 {
  margin: 0 0 20px;
}

.white {
  color: #fff;
}

.glop_dap .col-md-2 {
  display: inline-block;
  float: none;
  padding: 0 5px;
  width: 13%;
}

.glop_dap_sec form .row {
  width: 100%;
  margin: 0 !important;
}

.glop_dap_sec .quarl_toal {
  margin-top: 40px;
}

.glop_dap_sec .quarl_toal .control-form {
  border: 1px solid #dddddd;
  height: 34px;
  padding: 6px 12px;
  background-color: #ebeced;
  margin-left: 4px;
}

@media (max-width: 992px) {
  .glop_dap .col-md-2 {
    width: 20%;
    margin-bottom: 8px;
  }
}

@media (max-width: 575px) {
  .glop_dap .col-md-2 {
    width: 25%;
  }

  .glop_dap_sec .quarl_toal {
    margin-top: 20px;
  }

  .glop_dap_sec .quarl_toal label {
    width: 30%;
  }
}

@media (max-width: 425px) {
  .glop_dap .col-md-2 {
    width: 30%;
  }

  .glop_dap_sec .quarl_toal label {
    width: 50%;
  }
}
</style>